module.exports = __webpack_public_path__ + "img/ry6.89cb2a24.png";